<template>
  <div class="container">
    <h1 class="subs-title">Members List</h1>
    <div v-if="!$apollo.loading">
      <div class="buttons-container">
        <main-button
          depressed
          @click="goTo(routes.sportOrganization.sportOrganizationMembersCreate)"
        >
          <span class="add-symbol">+</span>
          Add membership
        </main-button>
        <div class="data-manage-buttons-container">
          <main-button
            color="#F5F5F5"
            style="color: #0277bd"
            @click="goTo(routes.sportOrganization.sportOrganizationMembershipsImport)"
          >
            <img
              src="/assets/import.svg"
              style="width: 1.8125rem; height: 1.8125rem"
              alt="import icon"
            >IMPORT
          </main-button>
          <a
            download
            :href="`${serverURL}/files/sport-organizations/${organizationSlug}/export/memberships/xlsx/${token}`"
          >
            <main-button color="#F5F5F5" style="color: #0277bd">
              <img
                src="/assets/export.svg"
                style="width: 1.8125rem; height: 1.8125rem"
                alt="export icon"
              >EXPORT
            </main-button>
          </a>
          <!--          <main-button-->
          <!--            color="#F5F5F5"-->
          <!--            style="color: #0277bd"-->
          <!--            @click="goTo(routes.sportOrganization.sportOrganizationSubscriptionsImport)"-->
          <!--          >-->
          <!--            <img-->
          <!--              src="/assets/import.svg"-->
          <!--              style="width: 1.8125rem; height: 1.8125rem"-->
          <!--              alt="import icon"-->
          <!--            />Send email-->
          <!--          </main-button>-->
        </div>
      </div>
      <v-text-field
        label="Search memberships"
        append-icon="search"
        box
        style="max-width: 42.75rem; margin: 1rem 0"
        @change="handleSearchChange($event)"
      />
      <div v-if="memberships.length === 0" class="d-flex justify-center">
        <span>No matching records found.</span>
      </div>
      <table-list
        v-else
        :selected.sync="selected"
        :organization-slug="organizationSlug"
        :attendees="memberships"
        body-style="grid-auto-columns: 50px minmax(150px, 250px) !important;"
        :visible-fields="visibleFields"
        :attendee-fields="attendeeFields"
        @click="handleTableRowClick"
        @send-email="handleSendEmailCLick"
      />
      <table-pagination
        :pagination="pagination"
        :total-attendees="totalCount"
        @change="handlePagination($event)"
        @changePerPage="handlePagination($event)"
      />
      <membership-details-modal
        v-if="membershipDetailsModalOpen"
        :membership="selectedMembership"
        @closeModal="membershipDetailsModalOpen = false"
      />
      <simple-snackbar v-bind.sync="snackbar" />
    </div>
  </div>
</template>

<script>
import { serverURL } from '@/utils'
import tableList from '../../accreditations/attendee-table/list.vue'
import moment from 'moment'
import { getSubscribersExportToken } from '@/http'
import {
  GET_ALL_SPORT_MEMBERSHIP_USERS_WITH_PAGINATION,
} from '@/graphql/membershipUser.graphql'
import tablePagination from '@/components/accreditations/attendee-table/pagination.vue'
import MembershipDetailsModal from '@/components/organizations/memberships/MembershipDetailsModal.vue'
import SimpleSnackbar from '@/components/shared/snackbars/simple-snackbar.vue'

export default {
  name: 'sport-members-list',
  components: {
    SimpleSnackbar,
    MembershipDetailsModal,
    tablePagination,
    tableList,
  },
  props: {
    organizationSlug: {
      type: String,
    },
  },
  data() {
    const { pagination } = this.getInitialFromQueryParams()

    return {
      serverURL,
      memberships: [],
      pagination,
      token: undefined,
      selected: [],
      organizerId: null,
      attendeeFields: {},
      visibleFields: ['Name', 'Code', 'Plan name', 'Bought', 'Expires', ''],
      totalCount: 0,
      searchTerm: null,
      selectedMembership: null,
      allMemberships: [],
      membershipDetailsModalOpen: false,
      snackbar: null,
    }
  },
  async created() {
    const { data } = await getSubscribersExportToken(this.organizationSlug)
    if (!data) {
      // handle
    }

    this.token = data.token
  },
  async mounted() {
    await this.fetchMemberships()
  },
  methods: {
    getInitialFromQueryParams() {
      const { per_page, page, sortBy, descending } = this.$route.query

      return {
        pagination: {
          page: parseInt(page, 10) || 1,
          per_page: parseInt(per_page, 10) || 10,
          sortBy: sortBy,
          descending: !!+descending,
        },
      }
    },
    async addPaginationToRoute({ page, per_page, sortBy, descending }) {
      await this.$router.replace({
        query: {
          ...this.$route.query,
          per_page,
          page,
          sortBy,
          descending: descending ? 1 : 0,
        },
      })

      await this.fetchMemberships()
    },
    async fetchMemberships() {
      const {
        data: { getAllMembershipUsersWithPagination },
        errors,
      } = await this.$apollo.query({
        query: GET_ALL_SPORT_MEMBERSHIP_USERS_WITH_PAGINATION,
        variables: {
          organizationSlug: this.organizationSlug,
          searchTerm: this.searchTerm,
          pagination: this.pagination,
        },
      })

      if (errors) {
        this.snackbar = {
          open: true,
          messageProp: 'Oops, Something went wrong!',
          color: 'error',
        }
      } else {
        this.totalCount = getAllMembershipUsersWithPagination.totalCount
        this.allMemberships = getAllMembershipUsersWithPagination.items
        this.memberships =
          getAllMembershipUsersWithPagination.items.map(membership => {
            return {
              id: membership.id,
              name: membership.name,
              code: membership.qrcode,
              'plan name': membership.membershipPlan.name,
              bought: moment(membership.createdAt).format('DD.MM.YYYY'),
              expires: membership.validUntil ? moment(membership.validUntil).format('DD.MM.YYYY') : '',
            }
          }) || {}
      }
    },
    async handleSearchChange(input) {
      this.searchTerm = input
      await this.fetchMemberships()
    },
    async handleTableRowClick(membershipId) {
      const membership = this.allMemberships.find((membership) => membership.id === membershipId)

      if(!membership) {
        return
      }

      this.selectedMembership = membership
      this.membershipDetailsModalOpen = true
    },
    async handlePagination({ page, per_page }) {
      const { page: currentPage, per_page: currentPerPage } = this.pagination
      if (currentPage > page && currentPage === 1) return
      if (page > currentPage && !(this.totalCount - currentPerPage * currentPage > 0)) return

      this.pagination = {
        ...this.pagination,
        per_page: per_page === 'All' ? -1 : per_page,
        page: page,
      }

      await this.addPaginationToRoute(this.pagination)
    },
    async handleSendEmailCLick(id) {
      const membershipUser = this.allMemberships.find(item => item.id === id)
      let errorMessage
      if (!membershipUser) {
        errorMessage = 'Something went wrong'
      } else if (!membershipUser.fields['Email']) {
        errorMessage = 'Please add email to member'
      }

      if (errorMessage) {
        this.snackbar = {
          open: true,
          messageProp: errorMessage,
          color: 'error',
        }

        return
      }

      await this.goTo(this.routes.sportOrganization.sportOrganizationMembershipsEmailsNew, {
        initialValues: {
          attendeeIds: [membershipUser.id],
          planId: membershipUser.membershipPlan.id,
        },
      })
    },
  },
}
</script>

<style scoped>
.container {
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  max-width: 64.875rem;
}

.subs-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}

.add-symbol {
  font-size: 1.875rem;
  margin-right: 0.8125rem;
  font-weight: 200;
}

.buttons-container {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  margin-top: 0;
  flex-wrap: wrap;
}

.data-manage-buttons-container {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}
</style>
